<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index, item)">
                                        <template v-if="item != 'action' && item != 'actions'">
                                            <template v-if="item[0].length != 1">
                                                <template v-if="item[0] == 'nama'">
                                                   <CRow>
                                                        <CCol sm="12">
                                                            <div class="ellps">
                                                                <span>
                                                                    {{body[item[0]]}}
                                                                </span>
                                                            </div>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <span style="color:rgba(154, 154, 154, 1);font-size:12px">
                                                                {{body[item[1]]}}
                                                            </span>
                                                        </CCol>
                                                    </CRow>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'penambah'">
                                                    {{separatorDetail(body[item])}}
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'aktif'">
                                                        <span v-if="body[item] == 'Y'" class="badge bg-success">Aktif</span>
                                                        <span v-else class="badge bg-secondary">Tidak Aktif</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'interval'">
                                                            {{separatorInterval(body[item])}}
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'totalGaji' || item == 'totalDitanggungPegawai'">
                                                                {{separatorRupiah(body[item])}}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'tglNonAktif' || item == 'tglAktif'">
                                                                    {{separatorTanggal(body[item])}}
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="item == 'totalPendapatan'">
                                                                        {{separatorRupiah(body[item])}}
                                                                    </template>
                                                                    <template v-else>
                                                                        {{body[item]}}
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action' && item != 'actions'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        </template>
                                        <template v-if="item != 'action' && item == 'actions'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                            <CButton @click="goView(id)" class="btn mr-2 btn-edit">View</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index" :style="loadStyle(index, item)">
                                    <template v-if="item != 'action' && item != 'actions'">
                                        <template v-if="item[0].length != 1">
                                            <template v-if="item[0] == 'nama'">
                                                <CRow>
                                                    <CCol sm="12">
                                                        <div class="ellps">
                                                            <span>
                                                                {{body[item[0]]}}
                                                            </span>
                                                        </div>
                                                    </CCol>
                                                    <CCol sm="12">
                                                        <span style="color:rgba(154, 154, 154, 1);font-size:12px">
                                                            {{body[item[1]]}}
                                                        </span>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-if="item == 'penambah'">
                                                {{separatorDetail(body[item])}}
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'aktif'">
                                                    <span v-if="body[item] == 'Y'" class="badge bg-success">Aktif</span>
                                                    <span v-else class="badge bg-secondary">Tidak Aktif</span>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'interval'">
                                                        {{separatorInterval(body[item])}}
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'totalGaji' || item == 'totalDitanggungPegawai'">
                                                            {{separatorRupiah(body[item])}}
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'tglNonAktif' || item == 'tglAktif'">
                                                                {{separatorTanggal(body[item])}}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'totalPendapatan'">
                                                                    {{separatorRupiah(body[item])}}
                                                                </template>
                                                                <template v-else>
                                                                    {{body[item]}}
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                    <template v-if="item == 'action' && item != 'actions'">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                    </template>
                                    <template v-if="item != 'action' && item == 'actions'">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        <CButton @click="goView(id)" class="btn mr-2 btn-edit">View</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        goView(id) {
            this.$emit('view', id)
        },
        loadStyle(index, item) {
            if( item == 'totalGaji' || item == 'totalPenghasilan' || item == 'totalPengurangan' ) {
                return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] + ';text-align:right;'
            } else {
                return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
            }
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorDetail(val) {
            if(val == 'A') {
                return 'Penghasilan Tetap'
            }
            if(val == 'B') {
                return 'Penghasilan Tidak Tetap'
            }
            if(val == 'C') {
                return 'Potongan Ditanggung Perusahaan'
            }
            if(val == 'D') {
                return 'Potongan Ditanggung Pegawai'
            }
            if(val == '') {
                return '-'
            }
        },
        separatorInterval(val) {
            if(val == 'H') {
                return 'Hari'
            } else if(val == 'M') {
                return 'Minggu'
            } else {
                return 'Bulan'
            }
        },
        separatorRupiah(val) {
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' + rupiah 
        },
        separatorTanggal(val) {
            if(val == '') {
                return '-'
            } else {
                let date = val.split(" ")[0]
                let tahun = date.split("-")[0]
                let tanggal = date.split("-")[2]
                let bulan = ''
                let month = date.split("-")[1]
                if(month == '01') {
                    bulan = 'Jan'
                } else if(month == '02') {
                    bulan = 'Feb'
                } else if(month == '03') {
                    bulan = 'Mar'
                } else if(month == '04') {
                    bulan = 'Apr'
                } else if(month == '05') {
                    bulan = 'Mei'
                } else if(month == '06') {
                    bulan = 'Jun'
                } else if(month == '07') {
                    bulan = 'Jul'
                } else if(month == '08') {
                    bulan = 'Agu'
                } else if(month == '09') {
                    bulan = 'Sep'
                } else if(month == '10') {
                    bulan = 'Okt'
                } else if(month == '11') {
                    bulan = 'Nov'
                } else if(month == '12') {
                    bulan = 'Des'
                }

                return tanggal + ' ' + bulan + ' ' + tahun
            }
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>